// Tanda 3 — Blindaje de datos: dispara el resguardo local semanal (una vez
// por sesión, sin bloquear nada) y avisa con un toast liviano si se generó.
import React, { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { maybeAutoLocalBackup } from "@/lib/localBackup";
import { toast } from "sonner";

export function LocalBackupScheduler() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    maybeAutoLocalBackup().then((counts) => {
      if (!counts) return;
      const total = Object.values(counts).reduce((a, v) => a + v, 0);
      toast.success(`Se guardó una copia de resguardo local en tu dispositivo (${total} registros).`, { duration: 6000 });
    });
  }, [user]);
  return null;
}
